import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import echo from '@/services/echo'
import { normalizeIncident } from '@/lib/incident'
import { showBrowserNotification } from '@/lib/notifications'

// Construye el cuerpo de la notificación: "Salón: Máquina — Tipo"
const buildBody = (inc) => {
  const site = inc.site?.name || inc.site_name || 'Salón'
  const maquina = inc.asset?.name || null
  const tipo = inc.type?.name || null
  let detalle
  if (maquina && tipo) detalle = `${maquina} — ${tipo}`
  else detalle = maquina || tipo || inc.title || 'Incidencia'
  return `${site}: ${detalle}.`
}

// Hook GLOBAL: se monta una vez (en Layout) y vive durante toda la sesión.
// Escucha incidencias nuevas por WebSocket y lanza una notificación del navegador.
// NO hace echo.leave('logistics') para no cargarse el canal compartido con
// las pantallas de Incidencias y Mapa: solo retira su propio listener.
export default function useIncidentNotifications() {
  const navigate = useNavigate()

  useEffect(() => {
    if (!echo?.connector?.pusher) return

    const channel = echo.private('logistics')

    const onCreated = (e) => {
      const inc = e?.incident ? normalizeIncident(e.incident) : null
      if (!inc) return
      const body = buildBody(inc)
      // Notificación nativa del navegador (puede silenciarla el SO si la
      // pestaña está en primer plano o en modo "No molestar").
      showBrowserNotification({
        title: 'Nueva incidencia',
        body,
        tag: `incident-${inc.id}`,
        onClick: () => navigate(`/incidents?open=${inc.id}`),
      })
      // Aviso visible dentro de la app (siempre se ve, estés donde estés).
      toast(`🔔 Nueva incidencia\n${body}`, { duration: 6000 })
    }

    channel.listen('.logistics.incident.created', onCreated)

    return () => {
      // Retira SOLO este listener; deja el canal vivo para las páginas.
      channel.stopListening('.logistics.incident.created', onCreated)
    }
  }, [navigate])
}
